import { Component, h, Host, Prop } from '@stencil/core';
import { AnchorInterface, generateAnchorAttributes, openURL } from '../../utils/elements-interface';

/**
 * @slot - Designed to add custom content inside the card.
 */

@Component({
  tag: 'sy-card',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Card implements AnchorInterface {
  /**
   * Defines whether card has all borders.
   */
  @Prop({ reflect: true }) border: 'bottom' | 'all' | 'none' = 'none';

  /**
   * Defines whether card has shadow or not.
   */
  @Prop({ reflect: true }) hideShadow = false;

  /**
  HTML <a> download attribute
  */
  @Prop() download: string;

  /**
   * HTML <a> href attribute
   */
  @Prop({ reflect: true }) href: string;

  /**
   * HTML <a> ref attribute
   */
  @Prop() rel: string;

  /**
   * HTML <a> target attribute
   */
  @Prop() target: '_blank' | '_self' | '_parent' | '_top';

  private getCardAttributes() {
    const attributes: any = {
      class: 'sy-card',
    };
    return attributes;
  }

  private handleClick = (event: Event) => {
    if (this.href) {
      openURL(this.href, event);
    }
  };

  render() {
    return (
      <Host onClick={this.handleClick}>
        {this.href ? (
          <a {...generateAnchorAttributes(this)} {...this.getCardAttributes()}>
            <slot></slot>
          </a>
        ) : (
          <div {...this.getCardAttributes()}>
            <slot></slot>
          </div>
        )}
      </Host>
    );
  }
}
